import { useState } from "react";
import { apiFetch } from "../api";
import { theme } from "../theme";

export const GROUP_COLORS = ["#126DFB", "#3b82f6", "#10b981", "#8b5cf6", "#6366f1", "#ec4899", "#06b6d4", "#84cc16"];

export default function GroupModal({ token, onClose, onSave }) {
  const [name, setName] = useState("");
  const [color, setColor] = useState(theme.blue);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleSave = async () => {
    if (!name.trim()) { setError("Zadej název."); return; }
    setLoading(true);
    try {
      const g = await apiFetch("/groups", token, { method: "POST", body: JSON.stringify({ name: name.trim(), color }) });
      onSave(g); onClose();
    } catch(e) { setError(e.message); }
    setLoading(false);
  };
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "#00000040", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100, padding: 24, backdropFilter: "blur(6px)" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: theme.bg, borderRadius: theme.rCard, width: "100%", maxWidth: 420, padding: 32, boxShadow: "0 24px 80px #00000020", fontFamily: theme.font }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <h2 style={{ color: theme.ink, fontSize: 19, fontWeight: 700 }}>Nová skupina</h2>
          <button onClick={onClose} style={{ width: 34, height: 34, borderRadius: theme.rBtn, border: `1.5px solid ${theme.line}`, background: theme.bg, color: theme.inkSoft, cursor: "pointer", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}><span style={{position:"relative",top:"-1px"}}>✕</span></button>
        </div>
        <input value={name} onChange={e => setName(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSave()} placeholder="např. Telefony, Tablety..." autoFocus style={{ width: "100%", border: `1.5px solid ${theme.line}`, borderRadius: 10, padding: "11px 14px", fontSize: 14, color: theme.ink, background: theme.bgSoft, marginBottom: 20, fontFamily: "inherit", boxSizing: "border-box" }} />
        <div style={{ display: "flex", gap: 8, marginBottom: 24, flexWrap: "wrap" }}>
          {GROUP_COLORS.map(c => <div key={c} onClick={() => setColor(c)} style={{ width: 28, height: 28, borderRadius: 8, background: c, cursor: "pointer", border: color === c ? `3px solid ${theme.ink}` : "3px solid transparent" }} />)}
        </div>
        {error && <p style={{ color: theme.bad, fontSize: 13, marginBottom: 14 }}>{error}</p>}
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, background: theme.bg, border: `1.5px solid ${theme.line}`, borderRadius: theme.rBtn, padding: "12px", color: theme.inkSoft, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>Zrušit</button>
          <button onClick={handleSave} disabled={loading} style={{ flex: 2, background: color, border: "none", borderRadius: theme.rBtn, padding: "12px", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>{loading ? "Ukládám…" : "Vytvořit"}</button>
        </div>
      </div>
    </div>
  );
}
